import { axios, AxiosResponse } from '@/config/plugins/axios';
import { FormValue } from '@/functions/getFormValue';
import { Pagination } from '@/types';

const dataLine = {
	fetchDataLines(
		projectToken: string,
		type: string,
		pagination: Pagination,
		advancedSearch?: any
	): Promise<AxiosResponse<any>> {
		const params = {
			itemsPerPage: pagination.itemsPerPage,
			sortDesc: pagination.sortDesc,
			page: pagination.page,
			sortBy: pagination.sortBy,
			advancedSearch
		};

		if (0 === pagination.sortBy?.length) {
			params.sortBy = null;
			params.sortDesc = null;
		}

		return axios.get(`/api/projects/${projectToken}/datalines/type/${type}`, { params });
	},

	createDataLine(projectToken: string, data: FormValue): Promise<AxiosResponse<any>> {
		return axios.post(`/api/projects/${projectToken}/datalines`, data);
	},

	deleteDataLine(projectToken: string, dataLineToken: string): Promise<AxiosResponse<any>> {
		return axios.delete(`/api/projects/${projectToken}/datalines/${dataLineToken}`);
	},

	getCreateDataLineForm(projectToken: string, data: any = {}): Promise<AxiosResponse<any>> {
		return axios.post(`/api/projects/${projectToken}/datalines/form`, data);
	},

	getEditDataLineForm(projectToken: string, dataLineToken: string, data: any = {}) {
		return axios.put(`/api/projects/${projectToken}/datalines/${dataLineToken}/form`, data);
	},

	editDataLine(projectToken: string, dataLineToken: string, data: FormValue) {
		return axios.put(`/api/projects/${projectToken}/datalines/${dataLineToken}`, data);
	},

	getDataLineListContext(projectToken: string, type: string): Promise<AxiosResponse<any>> {
		return axios.get(`/api/projects/${projectToken}/datalines/type/${type}/context`);
	},

	getDataLineWorkFlowContext(projectToken: string): Promise<AxiosResponse<any>> {
		return axios.get(`/api/projects/${projectToken}/datalines/workflow/context`);
	},

	applyTransition(dataLineTokens: string[], transition: string): Promise<AxiosResponse<any>> {
		return axios.post('/api/datalines/change-status', { 'dataLineIds': dataLineTokens, 'transition': transition });
	},

	getDataLinesAdvancedSearch(projectToken: string, type: string) {
		return axios.get(`/api/projects/${projectToken}/datalines/type/${type}/advanced-search`);
	}
};

export default dataLine;
